"use client";
import styles from "./ai-mastering-quick-tips-page.module.scss";
import ServicePageHeader from "@/components/common/service-page-header";
import { useMobile } from "@/hooks/use-responsive";
import FilledButton from "@/components/common/filled-button";
import Link from "next/link";
import React from "react";

const AiMasteringQuickTipsPage = () => {
  const { isMobile } = useMobile();
  return (
    <div className={styles.wrapper}>
      <ServicePageHeader
        title={
          <>
            Having <span>trouble</span> using AI Mastering?
          </>
        }
        description={
          "Welcome to Audiomodify! We’re thrilled to see the incredible AI Song Mastering results you’ll create with AudioModify."
        }
      />

      <div className={styles.title}>
        Please try the following steps to resolve the issue:
      </div>

      <ul className={styles.help_items}>
        <li>1. Reload the page and try using AI Mastering again.</li>
        <li>
          2. Check your internet connection. If you&apos;re using a VPN, try
          disabling it or switching to a more stable server.
        </li>
        <li>3. Try using AI Mastering in an incognito/private browser tab.</li>
        <li>
          4. Disable any browser extensions that might conflict with the
          AudioModify web application.
        </li>
        <li>5. Make sure your browser is up to date.</li>
        <li>6. Restart your device.</li>
      </ul>
      <div className={styles.title}>
        If the issue persists, try{" "}
        {isMobile && "accessing the desktop version or"} using a different
        device.
      </div>
      <Link href={"/help/contact"} className={styles.contact_button}>
        <FilledButton text={"Contact Support"} padding={"12px 45px"} />
      </Link>
    </div>
  );
};

export default AiMasteringQuickTipsPage;
